'use client';
import { usePathname } from 'next/navigation';

import { AnimatedBlob } from '@/components/AnimatedBlob';
import { CMSLink } from '@/components/Link';
import type { Header } from '@/payload-types';
import { cn } from '@/utils/cn';

import styles from './MobileNavigation.module.scss';

export function MobileNavigation({
  locale,
  mobileNavigation,
  open,
}: {
  mobileNavigation: Header['mobileNavigation'];
  locale: string;
  open: boolean;
}) {
  const pathname = usePathname();

  const primaryLinks = Array.isArray(mobileNavigation?.mobilePrimaryNavigation)
    ? mobileNavigation?.mobilePrimaryNavigation
    : mobileNavigation?.mobilePrimaryNavigation?.[locale] || [];

  const secondaryLinks = Array.isArray(
    mobileNavigation?.mobileSecondaryNavigation
  )
    ? mobileNavigation?.mobileSecondaryNavigation
    : mobileNavigation?.mobileSecondaryNavigation?.[locale] || [];

  if (primaryLinks?.length === 0 && secondaryLinks?.length === 0) return null;

  return (
    <div className={cn(styles.wrapper, open ? styles['active'] : '')}>
      <nav className={styles.navigation} aria-hidden={!open}>
        {primaryLinks?.map((item, index) => {
          const href =
            (item?.link.type === 'reference' &&
            typeof item?.link.reference?.value === 'object'
              ? typeof item?.link.reference?.value?.url === 'object'
                ? item?.link.reference?.value?.url?.[locale]
                : item?.link.reference?.value?.url
              : typeof item?.link.reference?.value === 'object'
                ? item?.link.reference?.value?.url
                : undefined) || item?.link.url;

          if (!href) return null;

          return (
            <CMSLink
              key={index}
              locale={locale}
              {...item?.link}
              className={cn(
                pathname.includes(`${href}/`) ? styles['activeLink'] : ''
              )}
            />
          );
        })}
      </nav>
      <nav className={styles.secondaryNavigation}>
        {secondaryLinks?.map((item, index) => {
          const href =
            (item?.link.type === 'reference' &&
            typeof item?.link.reference?.value === 'object'
              ? typeof item?.link.reference?.value?.url === 'object'
                ? item?.link.reference?.value?.url?.[locale]
                : item?.link.reference?.value?.url
              : typeof item?.link.reference?.value === 'object'
                ? item?.link.reference?.value?.url
                : undefined) || item?.link.url;

          if (!href) return null;

          return (
            <CMSLink
              key={index}
              locale={locale}
              {...item?.link}
              className={cn(
                pathname.includes(`${href}/`) ? styles['activeLink'] : ''
              )}
            />
          );
        })}
      </nav>
      <AnimatedBlob />
    </div>
  );
}
